import { slice } from 'lodash';
import { getBalanceOverrideColor } from 'application/util/balance-highlight.util';

import './calendar-list.style.sass';
import template from './calendar-list.tpl.pug';

class CalendarListController {
    /* @ngInject */
    constructor($q) {
        this.$q = $q;
    }

    $onInit() {
        this.sortableOptions = {
            animation: 100,
            onStart: this.startSort.bind(this),
            onEnd: this.endSort.bind(this)
        };
    }

    $onChanges(changeObject) {
        if (changeObject.calendars) {
            this.calendars = slice(this.calendars || []);
        }

        if (changeObject.multipleSelection || changeObject.canSelectMultiple) {
            this.multiple = this.multipleSelection && this.canSelectMultiple;
        }
    }

    get selectedCount() {
        return this.selectedCalendarIds && this.selectedCalendarIds.length > 0
            ? this.selectedCalendarIds.length
            : 0;
    }

    isActive(calendar) {
        return this.selectedCalendarIds && this.selectedCalendarIds.length > 0 && calendar && this.selectedCalendarIds.indexOf(calendar.id) >= 0;
    }

    add() {
        return this.onCalendarAdd();
    }

    delete(calendar) {
        return this.onCalendarDelete({
            calendar
        });
    }

    edit(calendar) {
        return this.onCalendarEdit({
            calendar
        });
    }

    select(calendar) {
        return this.onCalendarSelect({
            calendar
        });
    }

    editTeam() {
        return this.onTeamEdit();
    }

    toggleMultiple(multiple) {
        return this.onMultipleChange({
            multiple
        });
    }

    startSort() {
        this.sorting = true;
    }

    endSort() {
        return this.$q.when(this.onCalendarReorder({
            order: slice(this.calendars)
        })).finally(() => {
            this.sorting = false;
        });
    }

    getBalanceOverrideColor(value) {
        return getBalanceOverrideColor(value, this.balanceWarningThreshold);
    }
}

export default {
    selector: 'dbACalendarList',
    template: template(),
    controller: CalendarListController,
    bindings: {
        loading: '<',
        calendars: '<',
        selectedCalendarIds: '<',
        multipleSelection: '<multiple',
        canSelectMultiple: '<',
        balanceWarningThreshold: '<',

        owner: '<',
        plan: '<',
        canAdd: '<',

        onCalendarSelect: '&',
        onCalendarEdit: '&',
        onCalendarDelete: '&',
        onCalendarAdd: '&',
        onCalendarReorder: '&',
        onTeamEdit: '&',
        onMultipleChange: '&'
    }
};



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/calendar/component/calendar-navigation/component/calendar-list/calendar-list.cmpt.js